import { useEffect, useRef } from "react";
import { Animated, Easing, Platform } from "react-native";

// The Video.js skin reveals its control bar in 100ms and settles it out
// over 300ms on pointer-fine devices (150ms on touch) — player-skin.css,
// --media-controls-transition-duration. Every app-owned layer over the
// same player — the full PlayerChrome, AudioFeedChip, and HeroCastPill —
// must use this exact rhythm so the controls read as one surface.
const REVEAL_MS = 100;
const DISMISS_MS =
  Platform.OS === "web" &&
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  !window.matchMedia("(pointer: coarse)").matches
    ? 300
    : 150;

/** One visibility rhythm for app-owned controls layered over every player. */
export function usePlayerChromeOpacity(visible: boolean) {
  const opacity = useRef(new Animated.Value(visible ? 1 : 0)).current;

  useEffect(() => {
    const animation = Animated.timing(opacity, {
      duration: visible ? REVEAL_MS : DISMISS_MS,
      easing: Easing.out(Easing.cubic),
      toValue: visible ? 1 : 0,
      useNativeDriver: Platform.OS !== "web"
    });
    animation.start();
    return () => animation.stop();
  }, [opacity, visible]);

  return opacity;
}
